export default {
  tag: 'Test',
  tag_tooltip: 'Testrestaurant: volledig functioneel, nooit gefactureerd.',
  card: {
    title: 'Testrestaurant',
    description:
      "Markeer één restaurant als uw testrestaurant om printen, e-mails, bestellingen en integraties in productie te proberen. Het werkt als elk ander restaurant en wordt nooit gefactureerd. Klant-e-mails en sms'jes over zijn bestellingen beginnen met [TEST].",
    payments_note:
      'Betalingen bij het testrestaurant zijn echt en worden uitbetaald zoals bij elk ander restaurant. Restitueer testbestellingen zelf. We worden op de hoogte gesteld wanneer de maandelijkse verkoop de testdrempel overschrijdt.',
    designated_on: 'Gemarkeerd als test op {{date}}',
    open_shop: 'Winkel openen',
    remove: 'Testmarkering verwijderen',
    select_placeholder: 'Kies een restaurant',
    mark: 'Markeren als testrestaurant',
    no_restaurants: 'U heeft nog geen restaurant om te markeren.',
    load_error: 'Uw testrestaurant kon niet worden geladen.',
  },
  remove_confirm: {
    title: 'Testmarkering van {{name}} verwijderen?',
    description_live:
      'Facturering voor dit restaurant wordt hervat en het gaat meteen offline. Herlanceer het via Bestelinstellingen → Bestelmethoden → Live bestellingen, waar u het abonnement kiest.',
    description_stays_live: 'Dit restaurant blijft live en wordt vanaf nu weer behandeld als je andere restaurants.',
    description_offline:
      'Facturering voor dit restaurant wordt hervat zodra het live gaat. Het abonnement wordt gekozen wanneer u het lanceert.',
    confirm: 'Testmarkering verwijderen',
  },
  toasts: {
    designated: '{{name}} is nu uw testrestaurant. Het wordt niet gefactureerd.',
    designate_error: 'Het restaurant kon niet worden gemarkeerd als test. Probeer het opnieuw.',
    removed: '{{name}} is niet langer uw testrestaurant.',
    removed_offline: '{{name}} is niet langer uw testrestaurant en is nu offline.',
    remove_error: 'De testmarkering kon niet worden verwijderd. Probeer het opnieuw.',
  },
};
